<div class="language-switcher accordion">
    <button [attr.aria-expanded]="!isHidden" aria-controls="language_switcher_content" class="toggle accordion--button"
            (click)="isHidden = !isHidden">
        {{ selectedLanguage.display }}
    </button>
    <!-- accordion--content  -->
    <div id="language_switcher_content" class="accordion--content accordion--expanded" [attr.aria-hidden]="isHidden"
         [attr.hidden]="isHidden ? isHidden : null">
        <ul class="content links">
            <li *ngFor="let lang of languages">
                <span *ngIf="lang.value === selectedLanguage.value"><strong>{{lang.display}}</strong></span>
                <a *ngIf="lang.value !== selectedLanguage.value"
                   [href]="lang.value + route"
                   [hreflang]="lang.value"
                   [lang]="lang.value"
                   title="{{'Core.Header.LanguageSwitcher' + lang.display | translate}}">
                    {{lang.display}}
                </a>
            </li>
        </ul>
    </div>
</div>
